export const filtersToQueryString = (filters, search) => {
  const f = Object.keys(filters).reduce((cur, filterName) => {
    return `${cur}&${filterName}=${filters[filterName].join(',')}`;
  }, '');
  const s = `&search=${encodeURIComponent(search)}`;

  return search ? f + s : f;
};

export const initialFilters = (COLUMNS) => {
  const filters = {};

  COLUMNS.forEach((c) => {
    if (c.isFilterable && c.options) {
      filters[c.accessor] = [];
      c.options.forEach((o) => {
        if (o.selected) {
          filters[c.accessor].push(`${o.value}`);
        }
      });
    }
  });

  return filters;
};
